import { render, staticRenderFns } from "./felixItem.vue?vue&type=template&id=e2140508&scoped=true"
import script from "./felixItem.vue?vue&type=script&lang=js"
export * from "./felixItem.vue?vue&type=script&lang=js"
import style0 from "./felixItem.vue?vue&type=style&index=0&id=e2140508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2140508",
  null
  
)

export default component.exports